import { render, staticRenderFns } from "./GridResizeColumn.vue?vue&type=template&id=33a0f5e7&scoped=true&lang=pug"
import script from "./GridResizeColumn.vue?vue&type=script&lang=ts"
export * from "./GridResizeColumn.vue?vue&type=script&lang=ts"
import style0 from "./GridResizeColumn.vue?vue&type=style&index=0&id=33a0f5e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a0f5e7",
  null
  
)

export default component.exports